var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBulb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 104,
    height: 104,
    viewBox: "0 0 104 104",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M62.8333 86.6667H41.1667C40.0174 86.6667 38.9152 86.2101 38.1025 85.3975C37.2899 84.5848 36.8333 83.4826 36.8333 82.3333V77.1333C36.8207 75.9464 36.5685 74.7743 36.0919 73.6871C35.6154 72.6 34.9243 71.6203 34.06 70.8067C31.5033 68.3886 29.469 65.4724 28.0828 62.2379C26.6966 59.0033 25.9877 55.5191 26 52H30.3333C30.323 54.9315 30.9137 57.834 32.069 60.5283C33.2242 63.2226 34.9194 65.6515 37.05 67.665C38.3404 68.8831 39.3705 70.3502 40.078 71.9776C40.7856 73.6049 41.1559 75.3588 41.1667 77.1333V82.3333H62.8333V77.1333C62.8441 75.3588 63.2144 73.6049 63.922 71.9776C64.6295 70.3502 65.6596 68.8831 66.95 67.665C69.0806 65.6515 70.7758 63.2226 71.931 60.5283C73.0863 57.834 73.677 54.9315 73.6667 52H78C78.0123 55.5191 77.3034 59.0033 75.9172 62.2379C74.531 65.4724 72.4967 68.3886 69.94 70.8067C69.0757 71.6203 68.3846 72.6 67.9081 73.6871C67.4315 74.7743 67.1793 75.9464 67.1667 77.1333V82.3333C67.1667 83.4826 66.7101 84.5848 65.8975 85.3975C65.0848 86.2101 63.9826 86.6667 62.8333 86.6667Z",
    fill: "#1C1C1C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M78 52H73.6667C73.6667 46.2536 71.3839 40.7426 67.3206 36.6794C63.2574 32.6161 57.7464 30.3333 52 30.3333C46.2536 30.3333 40.7426 32.6161 36.6794 36.6794C32.6161 40.7426 30.3333 46.2536 30.3333 52H26C26 45.1044 28.7393 38.4912 33.6152 33.6152C38.4912 28.7393 45.1044 26 52 26C58.8956 26 65.5088 28.7393 70.3848 33.6152C75.2607 38.4912 78 45.1044 78 52Z",
    fill: "#1C1C1C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M67.1667 52H62.8333C62.8333 49.1268 61.692 46.3713 59.6603 44.3397C57.6287 42.308 54.8732 41.1667 52 41.1667V36.8333C56.0225 36.8333 59.8802 38.4312 62.7245 41.2756C65.5688 44.1199 67.1667 47.9776 67.1667 52Z",
    fill: "#1C1C1C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M62.8333 99.6667H41.1667V104H62.8333V99.6667Z",
    fill: "#1C1C1C"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M65 91H39V95.3333H65V91Z",
    fill: "#1C1C1C"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M54.1667 65H49.8333V84.5H54.1667V65Z",
    fill: "#1C1C1C"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M52 67.1667C51.6608 67.1646 51.3269 67.083 51.025 66.9283L42.3583 62.595L44.3083 58.7383L52 62.5733L59.6917 58.7383L61.6417 62.595L52.975 66.9283C52.6731 67.083 52.3392 67.1646 52 67.1667Z",
    fill: "#1C1C1C"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M104 49.8333H86.6667V54.1667H104V49.8333Z",
    fill: "#1C1C1C"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3333 49.8333H0V54.1667H17.3333V49.8333Z",
    fill: "#1C1C1C"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M89.4817 11.4497L76.4744 24.457L79.5386 27.5211L92.5458 14.5138L89.4817 11.4497Z",
    fill: "#1C1C1C"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5316 11.472L11.4675 14.5361L24.4747 27.5433L27.5388 24.4792L14.5316 11.472Z",
    fill: "#1C1C1C"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M24.4816 76.4636L11.4744 89.4708L14.5385 92.535L27.5458 79.5277L24.4816 76.4636Z",
    fill: "#1C1C1C"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M79.5455 76.472L76.4814 79.5361L89.4886 92.5433L92.5527 89.4792L79.5455 76.472Z",
    fill: "#1C1C1C"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M54.1667 0H49.8333V17.3333H54.1667V0Z",
    fill: "#1C1C1C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBulb);
export default __webpack_public_path__ + "static/media/bulb.82c5a8d3d576610865e715958927550c.svg";
export { ForwardRef as ReactComponent };